import React from 'react';
import { find, isNull } from 'lodash';

import { SimpleDonutChart } from '@magoosh/lib/charts';
import { toSentence } from 'utilities/formatting';

import StatisticData from '../statistic_data';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  examName: string;
  filters: any;
  sections?: any;
}

const PerformanceChart: React.FC<Props> = (props) => {
  const loadingPlaceholder = (
    <SimpleDonutChart
      chartProps={{ animate: false }}
      colorPalette={{ dark: colors.gray85, light: colors.grayLightest }}
      data={{ value: 60 }}
      interior={<></>}
      size={150}
    />
  );

  if (!props.filters) {
    return loadingPlaceholder;
  } else {
    return (
      <StatisticData
        filters={props.filters}
        name="performance"
      >
        <StatisticData.Loading>
          {loadingPlaceholder}
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <Chart sections={props.sections || []} />
      </StatisticData>
    );
  }
};

const Chart = ({ data, sections }) => {
  // Data may return multiple statistics if there is a mix of grading types and/or grading ranges.
  if (data.length === 1) {
    const datum = data[0];

    return (
      <div className="align-items-center d-flex flex-column gap-m">
        <SimpleDonutChart
          chartProps={{ animate: false }}
          colorPalette={{ dark: colors.dataDarkPurple, light: colors.dataMutedPurple }}
          data={datum}

          size={150}
        />

        {
          datum.range && (
            <div className="small text-gray-light">
              Scores range from {datum.range.low} to {datum.range.high}
            </div>
          )
        }
      </div>
    );
  } else {
    return (
      <div className="d-flex flex-column gap-m">
        {
          data.map((datum, idx) => {
            const sectionsWithGradingType = sections.filter((section) => (
              section.gradingTypes.indexOf(datum.label.toLowerCase()) !== -1
            ));

            return (
              <div key={idx} className="align-items-center d-flex flex-column gap-xs">
                <SimpleDonutChart
                  chartProps={{ animate: false }}
                  colorPalette={{ dark: colors.dataDarkPurple, light: colors.dataMutedPurple }}
                  data={datum}
                  size={100}
                />

                <div className="align-items-center d-flex flex-column">
                  {
                    sections.length > 0 && (
                      <small>{toSentence(sectionsWithGradingType.map((section) => section.name))}</small>
                    )
                  }

                  {
                    datum.range && (
                      <small className="text-gray-light">
                        Scores range from {datum.range.low} to {datum.range.high}
                      </small>
                    )
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    );
  }
};

export default PerformanceChart;
